import { useEffect, useState } from 'react'
import { Bar, BarChart, CartesianGrid, Tooltip, XAxis } from 'recharts'

import Spinner from '@/components/Spinner/Spinner'
import { useTheme } from '@/components/ThemeProvider/ThemeProvider'

type Props = {
  curve: Record<string, number>
}

const ManaCurvePanel = ({ curve }: Props) => {
  const [isLoaded, setIsLoaded] = useState(false)
  const [theme] = useTheme()

  // recharts does not render properly on the server, so we delay it until the client
  useEffect(() => {
    setIsLoaded(true)
  }, [])

  return (
    <div className='d-flex flex-column flex-grow-1 p-2'>
      <h5 className='d-flex justify-content-center w-100'>Average Mana Curve</h5>
      <div className='align-items-center d-flex h-100 justify-content-center'>
        {!isLoaded ? (
          <Spinner className='fa-2x' />
        ) : (
          <BarChart
            data={Object.keys(curve).map((k) => ({
              count: curve[k],
              name: k,
            }))}
            height={200}
            width={320}
          >
            <CartesianGrid strokeDasharray='3 3' />
            <XAxis dataKey='name' tick={{ fill: theme === 'dark' ? '#eaedf0' : '#22262a' }} />
            <Tooltip
              contentStyle={{ background: theme === 'dark' ? '#000' : '#fff' }}
              cursor={{ fill: theme === 'dark' ? '#333' : '#ccc' }}
            />
            <Bar dataKey='count' fill='#007bff' />
          </BarChart>
        )}
      </div>
    </div>
  )
}

export default ManaCurvePanel
